<mat-slide-toggle
  [checked]="_authorized"
  (change)="setAuthorized($event.checked)"
  color="primary"
  [disabled]="_authorized && !isAdmin"
  [matTooltip]="tooltipText"
  matTooltipClass="onsip-tooltip-background"
>
</mat-slide-toggle>
